import * as yup from "yup";

export const ClientSignUpSchema = yup.object({
  name: yup.string().required("Business name is required."),
  phone: yup
    .string()
    .required("Business phone number is required.")
    .matches(/^\d{10}$/, "Valid phone number must have 10 digits."),
  email: yup.string().email().required("Business email is required."),
  password: yup
    .string()
    .required("Password is required")
    .matches(/[a-z]+/, "Must have at least one lower case character.")
    .matches(/[A-Z]+/, "Must have at least one upper case character.")
    .matches(/[0-9]+/, "Must have at least one digit.")
    .matches(
      /[$&+,:;=?@#|'<>.^*()%!-]+/,
      "Must have at least one special character."
    )
    .min(12, "Must be 12 characters or more"),
  passwordConfirmation: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  terms: yup
    .bool()
    .required("The terms and conditions must be accepted.")
    .oneOf([true], "The terms and conditions must be accepted."),
});
